import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { sanitizeCoordinate } from "../../../utils/formatting";
import { STRINGS } from "../../../constants";
import { getMarkerIcon } from "../../../utils/helper";
import { logAnalyticsEvent } from "../../../utils/firebase";

/**
 * DetailsMapView component renders a Google Map with a marker based on the provided coordinates and screen type.
 *
 * @param {Object} props - The component props.
 * @param {string} props.name - The name to be displayed as the marker's title.
 * @param {number} props.lat - The latitude coordinate for the marker.
 * @param {number} props.lng - The longitude coordinate for the marker.
 * @param {string} props.screen - The type of screen to determine the marker icon.
 *
 * @returns {JSX.Element} The rendered Google Map with a marker.
 */
const DetailsMapView = ({ name, lat, lng, screen, type, color }) => {
  logAnalyticsEvent("screen_view", { name: `VBGo-${type}DetailsMapView` });

  const mapOptions = {
    clickableIcons: false,
    fullscreenControl: false,
    cameraControl: false,
    mapTypeControl: false,
    gestureHandling: "none",
  };
  const markerIcon =
    screen === STRINGS.parkingRoute
      ? getMarkerIcon(type || "default", color, "enabled")
      : screen === STRINGS.attractionsRoute
      ? require("../../../assets/images/attraction-point-enabled.png")
      : screen === STRINGS.bathroomRoute
      ? require("../../../assets/images/bathroom-point-enabled.png")
      : null;

  return (
    <GoogleMap
      mapContainerStyle={{ height: "100%", width: "100%" }}
      center={{ lat: sanitizeCoordinate(lat), lng: sanitizeCoordinate(lng) }}
      zoom={15}
      options={mapOptions}
    >
      <Marker
        position={{ lat: sanitizeCoordinate(lat), lng: sanitizeCoordinate(lng) }}
        icon={markerIcon}
        title={name}
      />
    </GoogleMap>
  );
};

export default DetailsMapView;
